import React from "react";
import {Query} from "react-apollo";
import StatusStepsPanel from "../../shared/StatusStepsPanel";
import {GET_STOCK_TRANSFER} from "../../../queries/stockTransfers";

const STEPS = [
  {id: "draft", title: "Draft"},
  {id: "in_transit", title: "In Transit"},
  {id: "received", title: "Received"},
];

const StockTransferStatusPanel = ({transferId}) => (
  <Query query={GET_STOCK_TRANSFER} variables={{id: transferId}} fetchPolicy="cache-and-network">
    {({data}) => (
      <StatusStepsPanel
        title="Transfer Status"
        steps={STEPS}
        status={data && data.stockTransfer && data.stockTransfer.status}
        cancelledText="This transfer has been cancelled." />
    )}
  </Query>
);

export default StockTransferStatusPanel;
